import React from 'react';
import r2wc from '@r2wc/react-to-web-component';
import { R2WCOptions } from '@r2wc/core';

type MakeR2wcProps = {
  /**
   * Class that should be added onto the mounted web component.
   */
  className: string;

  /**
   * React context for the mounted web component.
   */
  context: React.ComponentType;
};

/**
 * Return an instance of r2wc to register new React component as web component.
 *
 * @param {MakeR2wcProps} props
 */
export function makeR2wc({ context, className }: MakeR2wcProps) {
  return function register<P extends object>(
    name: string,
    component: React.ComponentType<P>,
    props?: R2WCOptions<P>['props'],
  ): void {
    const factoryComponent = (props: P) =>
      React.createElement(context, null, React.createElement(component, props));

    const reactWebComponent = class WebComponent extends r2wc(factoryComponent, {
      props,
    }) {
      connectedCallback() {
        if (!super.connectedCallback) {
          return;
        }

        super.connectedCallback();

        if (!this.isConnected) {
          return;
        }

        this.classList.add(className);
      }
    };

    customElements.define(name, reactWebComponent);
  };
}
